import type { ReleaseItem, ProductUpdate } from './product-updates-types';
import { generateStableId, isReleaseViewed } from './product-updates-storage';

export function transformRelease(release: ReleaseItem): ProductUpdate {
  const id = generateStableId(release.date, release.title);
  const releaseDate = new Date(release.date);
  const unixTimestamp = Math.floor(releaseDate.getTime() / 1000);
  const linkUrl = release.link.startsWith('http') ? release.link : `https://docs.customer.io${release.link}`;

  return {
    id,
    title: release.title,
    body: release.description,
    linkText: release.linkText ?? 'Learn more',
    linkUrl,
    activated: unixTimestamp,
    updated: unixTimestamp,
    created: unixTimestamp,
    viewed: isReleaseViewed(id) ? unixTimestamp : null,
  };
}

export function getUnviewedUpdates(updates: ProductUpdate[]): ProductUpdate[] {
  return updates.filter((update) => update.viewed === null);
}
